<template>
  <b-nav-item
    :is="baseComponent"
    :to="link.path ? link.path : '/'"
    class="nav-item"
    :class="{ active: isActive }"
  >
    <a
      v-if="isMenu"
      class="sidebar-menu-item nav-link d-flex justify-content-between align-items-center"
      :class="{ active: isActive }"
      :aria-expanded="!collapsed"
      @click.prevent="collapseMenu"
    >
      <span class="d-flex align-items-center">
        <b-icon v-if="link.icon" :icon="link.icon" class="mr-2" style="color: #525f7f !important;"/>
        <span class="nav-link-text" style="color: #525f7f !important;">{{ link.name }}</span>
      </span>

      <transition name="fade">
        <span>
          <b-icon-caret-down-fill v-if="collapsed" class="nav-link-text" />
          <b-icon-caret-up-fill v-else class="nav-link-text" />
        </span>
      </transition>
    </a>

    <collapse-transition>
      <div
        v-if="$slots.default || isMenu"
        v-show="!collapsed"
        class="collapse show"
      >
        <ul class="nav nav-sm flex-column">
          <slot></slot>
        </ul>
      </div>
    </collapse-transition>

    <slot
      name="title"
      v-if="children.length === 0 && !$slots.default && link.path"
    >
      <component
        :to="link.path"
        @click.native="linkClick"
        :is="elementType(link, false)"
        class="nav-link d-flex align-items-center"
        :class="{ active: isActive, 'm-0': false }"
        :target="link.target"
        :href="link.path"
      >
        <div :class="{ 'transform-text': isActive && link.path != '/'}">
          <b-icon v-if="link.icon" :icon="link.icon" class="mr-2" />
          <span class="nav-link-text">{{ link.name }}</span>
        </div>
      </component>
    </slot>
  </b-nav-item>
</template>

<script>
import { CollapseTransition } from 'vue2-transitions';

export default {
  name: 'sidebar-item',
  components: {
    CollapseTransition
  },
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: () => ({
        name: '',
        path: '',
        children: []
      })
    }
  },
  provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    };
  },
  inject: {
    addLink: { default: null },
    removeLink: { default: null },
    autoClose: { default: true }
  },
  data() {
    return {
      children: [],
      collapsed: true
    };
  },
  computed: {
    baseComponent() {
      return this.isMenu || this.link.isRoute ? 'li' : 'router-link';
    },
    isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
isActive() {
  if (this.link.path == undefined) {
    let activeMemory = localStorage.getItem(`${this.link.name.toLowerCase()}-expanded`)
    if (activeMemory === 'true') {
      return true
    }
  }

  if (!this.$route || !this.$route.path) return false;

  // If this item has a path, check if route path matches exactly or starts with it + slash
  if (this.link.path) {
    const current = this.$route.path;
    const base = this.link.path.split('?')[0];

    return current === base || current.startsWith(base + '/');
  }

  // If no path but has children, check if any child is active
  return this.children.some(c => {
    if (!c.link?.path) return false;
    const current = this.$route.path;
    const childBase = c.link.path;
    return current === childBase || current.startsWith(childBase + '/');
  });
}
  },
  methods: {
    addChild(item) {
      const index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild(item) {
      const index = this.children.indexOf(item);
      if (index !== -1) {
        this.children.splice(index, 1);
      }
    },
    elementType(link, isParent = true) {
      return link.isRoute === false ? (isParent ? 'li' : 'a') : 'router-link';
    },
    linkClick() {
      if (this.autoClose && this.$sidebar?.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    collapseMenu() {
      this.collapsed = !this.collapsed;
      if (!this.collapsed) {
        localStorage.setItem(`${this.link.name.toLowerCase()}-expanded`, true)
      } else {
        localStorage.setItem(`${this.link.name.toLowerCase()}-expanded`, false)
      }
    }
  },
  created() {
    if (this.link.path == undefined) {
      if (localStorage.getItem(`${this.link.name.toLowerCase()}-expanded`) == null) localStorage.setItem(`${this.link.name.toLowerCase()}-expanded`, false);
    }
  },
  mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  destroyed() {
    this.removeLink?.(this);
  }
};
</script>

<style scoped>
.sidebar-menu-item {
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.nav-link.active:not(.sidebar-menu-item) {
  border-radius: 0.5rem;
  margin: auto 0.5rem;
  color: white;
  font-weight: 900;
  background-color: rgb(19, 117, 166);
}

.transform-text {
  transform: translateX(-0.5rem);
}
</style>